<template>
    <div class="navbar-header hidden-xs">
        <a href="#/profile" class="navbar-brand">
            <img
                data-test-id="nav-bar-logo-image"
                :src="src"
                :height="height"
                :width="width"
                :alt="name"
            />
            <!-- Content needed for accessibility -->
            <span style="display:none;">Logo</span>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        src: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
    },
    computed: {
        isDefaultLogo() {
            return this.src === "/img/leapsome.png";
        },
        height() {
            return 25;
        },
        width() {
            return this.isDefaultLogo ? 111 : "";
        },
    },
};
</script>

<style scoped></style>
